export const WEB_NAME = `西睿餐饮排队系统${process.env.APP_TYPE === 'management' ? '(管理端)' : '(门店端)'}`

const getEnum = (data) => {
  return data.reduce((total, curr) => {
    total[curr.enumKey] = curr.id
    return total
  }, {})
}
const getEnumKey = (data) => {
  return data.reduce((total, curr) => {
    total[curr.enumKey] = curr.enumKey
    return total
  }, {})
}
//获取下拉数据类型对象
export const COMMON_OPTION_TYPE = {
  SUPPLIER: 'supplier',
  HOTEL: 'hotel',
  VENUE: 'venue',
  FACILITY: 'FACILITY',
  LABEL: 'SPECIAL_LABEL',
  SERVICE_ITEMS: 'SERVICE_ITEMS',
  CONTENT: 'content',
  MEETING_TYPE: 'MEETING_TYPE',
  VENUE_CONTAIN: 'PEOPLE_NUMBER'
}

export const WHETHER_STATUS = [
  { id: 0, name: '否', enumKey: 'NO' },
  { id: 1, name: '是', enumKey: 'YES' }
]

export const RESERVE_ORDER_SOURCE = 'MANAGEMENT_PLATFORM'

export const RESERVE_ORDER_STATUS = [
  { id: 0, name: '未确认', enumKey: 'NOT_CONFIRM' },
  { id: 1, name: '已确认', enumKey: 'CONFIRM' },
  { id: 2, name: '已取消', enumKey: 'CANCELED' }
]
export const RESERVE_ORDER_STATUS_ENUM: any = getEnum(RESERVE_ORDER_STATUS)
export const RESERVE_ORDER_STATUS_ENUM_KEY: any = getEnumKey(RESERVE_ORDER_STATUS)

export const CONSULT_ORDER_TYPES = [
  { id: 1, name: '智能匹配', enumKey: 'AUTO_MATCH' },
  { id: 2, name: '咨询请求', enumKey: 'CONSULT_REQUEST' }
]
export const CONSULT_ORDER_STATUS = [
  { id: 2, name: '未沟通', enumKey: 'NOT_CONTACT' },
  { id: 1, name: '已沟通', enumKey: 'CONTACTED' }
]
export const CONSULT_ORDER_STATUS_ENUM: any = getEnum(CONSULT_ORDER_STATUS)
export const CONSULT_ORDER_STATUS_ENUM_KEY: any = getEnumKey(CONSULT_ORDER_STATUS)

export const HOTEL_STAR_LEVEL = [
  { id: 0, name: '无' },
  { id: 1, name: '一星级' },
  { id: 2, name: '二星级' },
  { id: 3, name: '三星级' },
  { id: 4, name: '四星级' },
  { id: 5, name: '五星级' }
]

export const HOTEL_MATCH_LEVEL = [
  { id: 1, name: '一级' },
  { id: 2, name: '二级' },
  { id: 3, name: '三级' }
]
export const MEMBER_VIP_LEVEL = [
  { id: 0, name: '普通用户' },
  { id: 1, name: '铜牌会员' },
  { id: 2, name: '银牌会员' },
  { id: 3, name: '金牌会员' }
]
export const SEX_OPTIONS = [
  { id: 0, name: '女' },
  { id: 1, name: '男' }
]
export const CONTENT_TYPES = [
  { id: 0, name: '资讯', enumKey: 'INFORMATION' },
  { id: 1, name: '会议历史', enumKey: 'MEETING_HISTORY' },
  { id: 2, name: '广告', enumKey: 'ADVERTISEMENT' },
  { id: 3, name: '介绍', enumKey: 'INTRODUCE' }
]
export const CONTENT_TYPE_ENUM: any = getEnum(CONTENT_TYPES)

export const ONLINE_FLAGS = [
  { id: 0, name: '草稿', enumKey: 'CRAFT', color: '' },
  { id: 1, name: '已发布', enumKey: 'PUBLISHED', color: 'green' },
  { id: 2, name: '已下线', enumKey: 'UNLINE', color: 'red' }
]
export const ONLINE_FLAG_ENUM: any = getEnum(ONLINE_FLAGS)

export const CONTENT_ARTICLE_TYPES = [
  { id: 0, name: '图文', enumKey: 'IMAGE' },
  { id: 1, name: '外链接', enumKey: 'LINK' }
]
export const CONTENT_ARTICLE_TYPE_ENUM: any = getEnum(CONTENT_ARTICLE_TYPES)

export enum RANKING_STATUS {
  WAITING,
  EATING,
  PASSED,
  CANCEL
}
export const RANKING_STATUS_MAP = {
  [RANKING_STATUS.WAITING]: '等待中',
  [RANKING_STATUS.EATING]: '就餐中',
  [RANKING_STATUS.PASSED]: '已过号',
  [RANKING_STATUS.CANCEL]: '已取消'
}
